import { resolveMenuRoute } from '@/utils/sidebarRouteResolver'

/**
 * 侧栏 / menuNav 子菜单卡片树工具（支持多级：父级卡片 → 子级卡片 → 功能页）。
 */

/** 雪花 id 须字符串比较；Number 回退兼容 JSON 解析丢精度 */
export function menuIdsEqual (a, b) {
  if (a == null || b == null) return false
  const sa = String(a).trim()
  const sb = String(b).trim()
  if (sa === sb) return true
  const na = Number(sa)
  const nb = Number(sb)
  return !Number.isNaN(na) && !Number.isNaN(nb) && na === nb
}

export function findMenuNodeInTree (nodes, id) {
  if (!Array.isArray(nodes) || id == null) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (menuIdsEqual(n.id, id)) return n
    const hit = findMenuNodeInTree(n.menuList, id)
    if (hit) return hit
  }
  return null
}

export function findMenuParentChain (nodes, id, chain = []) {
  if (!Array.isArray(nodes) || id == null) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (menuIdsEqual(n.id, id)) return chain
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findMenuParentChain(n.menuList, id, chain.concat(n))
      if (hit) return hit
    }
  }
  return null
}

/** 目錄節點下所有子菜單 id（含自身），供試用角標向下繼承 */
export function collectMenuSubtreeIds (menu) {
  const out = []
  const walk = (node) => {
    if (!node || node.id == null) return
    out.push(node.id)
    getNavChildren(node).forEach(walk)
  }
  walk(menu)
  return out
}

export function getNavChildren (menu) {
  if (!menu || !Array.isArray(menu.menuList)) return []
  // type=2 為按鈕，不進導航卡片／不算目錄子項
  return menu.menuList.filter((m) => m && Number(m.type) !== 2)
}

export function menuHasNavChildren (menu) {
  return getNavChildren(menu).length > 0
}

export function collectLeafMenuTitles (menu, limit, titleOf) {
  const out = []
  const walk = (node) => {
    if (!node || out.length >= limit) return
    const children = getNavChildren(node)
    if (!children.length) {
      const t = titleOf(node)
      if (t) out.push(t)
      return
    }
    for (let i = 0; i < children.length; i++) {
      if (out.length >= limit) break
      walk(children[i])
    }
  }
  walk(menu)
  return out
}

export function buildMenuNavCardDesc (menu, dynamicMenuRoutes, resolveMenuRoute, titleOf) {
  if (menuHasNavChildren(menu)) {
    const names = collectLeafMenuTitles(menu, 3, titleOf)
    return names.length ? names.join(' / ') : '查看子選單'
  }
  const route = resolveMenuRoute(dynamicMenuRoutes, menu)
  if (route && route.meta && route.meta.title) return route.meta.title
  return '進入此功能頁面'
}

export function collectLeafMenus (menu, out = []) {
  if (!menu) return out
  const children = getNavChildren(menu)
  if (!children.length) {
    out.push(menu)
    return out
  }
  for (let i = 0; i < children.length; i++) collectLeafMenus(children[i], out)
  return out
}

/** 目錄／分組卡片：向下找第一個可解析路由（與 home 首頁卡片一致） */
export function findFirstRouteByMenu (menu, dynamicMenuRoutes, resolveMenuRouteFn) {
  const resolveFn = resolveMenuRouteFn || resolveMenuRoute
  if (menu && menu.url && /\S/.test(String(menu.url))) {
    const selfRoute = resolveFn(dynamicMenuRoutes, menu)
    if (selfRoute && selfRoute.name) return selfRoute
  }
  const leaves = collectLeafMenus(menu)
  for (let i = 0; i < leaves.length; i++) {
    const route = resolveFn(dynamicMenuRoutes, leaves[i])
    if (route && route.name) return route
  }
  return null
}

/** 點側欄菜單名（非展開箭頭）。箭頭點擊應另開 menuNav。 */
export function isSidebarMenuNameClick (target) {
  return !!(target && typeof target.closest === 'function' && target.closest('.site-sidebar__submenu-title'))
}



// WEBPACK FOOTER //
// ./src/utils/menuNavTree.js